module.exports = __webpack_public_path__ + "static/img/wrong.9630d71.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/simple/appWrong/images/wrong.png
// module id = WEJk
// module chunks = 34